import * as styleguide from "./styleguide";

export default styleguide;
